import { __assign, __rest } from "tslib";
import React from 'react';
import IconButton from '../../../Button/IconButton/IconButton';
import { ReactPopperReference } from '../../../Popover/PopperPopover/ReactPopper';
import { DropdownStateContext } from '../../DropdownStateManager';
import { PopperDropdownManager, PopperDropdownContent, } from '../../PopperDropdownLayout';
export var IconButtonWithPopover = function (_a) {
    var popoverChildren = _a.popoverChildren, children = _a.children, className = _a.className, placement = _a.placement, innerRef = _a.innerRef, popoverAriaLabel = _a.popoverAriaLabel, popoverRole = _a.popoverRole, isInPopup = _a.isInPopup, biData = _a.biData, _b = _a.onOpenBiData, onOpenBiData = _b === void 0 ? biData : _b, _c = _a.onCloseBiData, onCloseBiData = _c === void 0 ? biData : _c, rest = __rest(_a, ["popoverChildren", "children", "className", "placement", "innerRef", "popoverAriaLabel", "popoverRole", "isInPopup", "biData", "onOpenBiData", "onCloseBiData"]);
    return (React.createElement(PopperDropdownManager, { isInPopup: isInPopup },
        React.createElement(DropdownStateContext.Consumer, null, function (_a) {
            var setToggleRef = _a.setToggleRef, isOpen = _a.isOpen;
            return (React.createElement(React.Fragment, null,
                React.createElement(ReactPopperReference, null, function (_a) {
                    var setPopperRef = _a.ref;
                    return (React.createElement(IconButton, __assign({ "aria-haspopup": true, "aria-expanded": isOpen, className: className, innerRef: function (node) {
                            setToggleRef(node);
                            setPopperRef(node);
                            if (innerRef) {
                                innerRef(node);
                            }
                        }, biData: isOpen ? onCloseBiData : onOpenBiData }, rest), children));
                }),
                React.createElement(PopperDropdownContent, { placement: placement, usePortal: true, role: popoverRole, "aria-label": popoverAriaLabel }, popoverChildren)));
        })));
};
IconButtonWithPopover.displayName = 'IconButtonWithPopover';
export default IconButtonWithPopover;
//# sourceMappingURL=IconButtonWithPopover.js.map